import './*.scss'
import { media } from "../../assets/js/utilities/media.js";

function setup({ el }) {
	/* The original element that requested the module */
	const context = el;

	/* Context sensitive things to target */
	const selectors = {
		questionTriggers: context.dataset.moduleTargets,
	};

	/* Find all of the above */
	const questionTriggers = context.querySelectorAll(`.${selectors.questionTriggers}`);

	/* Loop through the elements */
	questionTriggers.forEach((trigger) => {
		trigger.addEventListener("click", (event) => {
      if(media.is("sm", "max")) {
        event.preventDefault();
      }
			trigger.parentElement.classList.toggle("is-active");
		});
	});
}

function init() {
	document.querySelectorAll("[data-module='accordion']").forEach((el) => {
		setup({ el });
	});
}

export default init
